const {
	MAIN_EASING,
	DELAY_DEBOUNCE,
	DELAY_THROTTLE,
} = require('../../../../js/consts');
const {
	stuttering,
	default: onWidthResize,
} = require('../../../../js/onWidthResize');
const DIRECTION_LEFT = 2;
const DIRECTION_RIGHT = 4;
const CLASS_CURRENT_LETTER = 'current';
const { getNumber, trackGtm4 } = require('../../../../js/functions');
let { evenSlowerDelay } = require('../../../../js/sass-variables').default;
const asyncImport = require('util/asyncImport').default;

evenSlowerDelay = getNumber(evenSlowerDelay);

module.exports = {
	async init() {
		this.currentLetterIndex = 0;
		this.slider = this.root.querySelector('.index--letters');
		this.sliderLetters = this.root.querySelectorAll(
			'.index--letters li button',
		);
		this.previousButton = this.root.querySelector('.slider--prev');
		this.nextButton = this.root.querySelector('.slider--next');
		this.results = Array.from(this.root.querySelectorAll('.result'));
		this.articles = this.root.querySelectorAll('.result--articles');
		this.readMoreLinks = this.root.querySelectorAll('.read-more');
		this.mainTitle = this.root.querySelector('.index--title');
		await asyncImport(this, ['anime', 'Sticky', 'throttle', 'Hammer']);
		this.throttledHandlerObserver = this.throttle(
			this.handlerObserver.bind(this),
			DELAY_THROTTLE,
		);
		this.spaceBetweenSliderAndElements = 150;
		this.smallButtonSize = this.sliderLetters[1].clientWidth;
		this.resultsPositions = this.getResultPosition();
		this.handlerObserver();
		this.indexHammer = new this.Hammer(
			this.root.querySelector('.slider-container'),
		);
		this.swiperBasicVelocity = 2;

		/* --- Get main title for gtm4 methods --- */

		const title = this.mainTitle ? this.mainTitle.innerHTML : 'No title';

		/* ----------- */

		this.previousButton.addEventListener('click', e => {
			const text = e.target.innerHTML
				? e.target.innerHTML
				: e.target.getAttribute('aria-label')
				? e.target.getAttribute('aria-label')
				: 'No text';
			const url = e.target.href ? e.target.href : 'No url';
			this.decreaseSlider();
			this.navigationTrackingGtm4(title, text, url);
		});
		this.nextButton.addEventListener('click', e => {
			const text = e.target.innerHTML
				? e.target.innerHTML
				: e.target.getAttribute('aria-label')
				? e.target.getAttribute('aria-label')
				: 'No text';
			const url = e.target.href ? e.target.href : 'No url';
			this.increaseSlider();
			this.navigationTrackingGtm4(title, text, url);
		});

		this.sliderLetters.forEach((letter, index) => {
			letter.addEventListener('click', () => {
				const text = letter ? letter.innerHTML.trim() : 'No text';
				const url = letter.href ? letter.href : 'No url';
				this.handlerLetterButton(index);
				this.navigationTrackingGtm4(title, text, url);

				let first = true;
				const allArticles = document.querySelectorAll('.result--item');

				allArticles.forEach(element => {
					if (
						element.parentNode.getAttribute('data-articles') ==
							letter.getAttribute('data-letter') &&
						first
					) {
						element.focus();
						first = false;
					}
				});
			});
		});

		this.readMoreLinks.forEach(readMoreLink => {
			readMoreLink.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Glossary',
					widget_title: this.mainTitle.innerText,
					link_text: readMoreLink.innerHTML,
					link_url: readMoreLink.href,
					button_type: '',
				});
			});
		});

		document.addEventListener('keydown', event => {
			this.sliderLetters.forEach(letter => {
				const currentLetter = letter.getAttribute('data-letter');
				const currentKey = event.key;

				if (currentLetter == currentKey.toUpperCase()) {
					letter.focus();
				}
			});
		});

		this.indexHammer.on('swipe', pointer => this.handlerSwipe(pointer));

		window.addEventListener('scroll', this.throttledHandlerObserver);
		onWidthResize(
			this.handlerResize.bind(this),
			stuttering.DEBOUNCE,
			DELAY_DEBOUNCE,
		);

		return new this.Sticky('.slider-container');
	},

	handlerObserver() {
		const newCurrentStep = this.findCurrentIndex();

		if (this.currentLetterIndex !== newCurrentStep) {
			this.updateSlider(newCurrentStep);
		}
	},

	handlerResize() {
		this.resultsPositions = this.getResultPosition();
		this.handlerObserver();
	},

	/* ---- handler for navigation tracking ---- */

	navigationTrackingGtm4(title, text, url) {
		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Glossary',
			widget_title: title,
			widget_type: 'article',
			link_text: text,
			link_url: url,
			interaction_type: `glossary navigation ${text}`,
		});
	},

	/* ---- handlers for buttons in slider ---- */

	increaseSlider() {
		if (this.currentLetterIndex < this.sliderLetters.length - 1) {
			this.scrollToIndex(this.currentLetterIndex + 1);
		}
	},

	decreaseSlider() {
		if (this.currentLetterIndex > 0) {
			this.scrollToIndex(this.currentLetterIndex - 1);
		}
	},

	handlerLetterButton(letterIndex) {
		if (letterIndex !== this.currentLetterIndex) {
			this.scrollToIndex(letterIndex);
		}
	},

	/* ---- handlers for buttons in slider ---- */

	/* ---- handlers for swipe ---- */

	handlerSwipe(pointer) {
		const velocity = Math.abs(Math.round(pointer.velocity));

		if (pointer.offsetDirection === DIRECTION_LEFT) {
			this.handleSwipeLeft(velocity);
		}

		if (pointer.offsetDirection === DIRECTION_RIGHT) {
			this.handleSwipeRight(velocity);
		}
	},

	handleSwipeLeft(velocity) {
		const distanceOfSlider =
			this.currentLetterIndex + velocity + this.swiperBasicVelocity;

		if (distanceOfSlider <= this.resultsPositions.length - 1) {
			this.scrollToIndex(distanceOfSlider);
		}

		if (
			distanceOfSlider > this.resultsPositions.length - 1 &&
			this.currentLetterIndex !== this.resultsPositions.length - 1
		) {
			this.scrollToIndex(this.resultsPositions.length - 1);
		}
	},

	handleSwipeRight(velocity) {
		const distanceOfSlider =
			this.currentLetterIndex - velocity - this.swiperBasicVelocity;

		if (distanceOfSlider >= 0) {
			this.scrollToIndex(distanceOfSlider);
		}

		if (distanceOfSlider < 0 && this.currentLetterIndex !== 0) {
			this.scrollToIndex(0);
		}
	},

	/* ---- /handlers for swiper ---- */

	/* ---- basics method ---- */

	getResultPosition() {
		return this.results.map(result =>
			Math.round(
				result.getBoundingClientRect().top +
					window.pageYOffset -
					this.spaceBetweenSliderAndElements,
			),
		);
	},

	findCurrentIndex() {
		const index = this.resultsPositions.findIndex(
			position => window.pageYOffset < position,
		);

		return this.analyseIndex(index);
	},

	analyseIndex(index) {
		if (index === -1) return this.resultsPositions.length - 1;
		return index - 1 === -1 ? 0 : index - 1;
	},

	updateSlider(targetIndex) {
		this.removeClassOnCurrentLetter();
		this.updateCurrent(targetIndex);
		this.addClassOnCurrentLetter();
		this.moveSlider();
	},

	scrollToIndex(destinationIndex) {
		this.animation = this.anime({
			targets: document.scrollingElement,
			scrollTop: this.resultsPositions[destinationIndex],
			easing: MAIN_EASING,
			duration: evenSlowerDelay * 1000,
		});
	},

	updateCurrent(newCurrentValue) {
		this.currentLetterIndex = newCurrentValue;
	},

	addClassOnCurrentLetter() {
		this.sliderLetters[this.currentLetterIndex].classList.add(
			CLASS_CURRENT_LETTER,
		);
	},

	removeClassOnCurrentLetter() {
		this.sliderLetters[this.currentLetterIndex].classList.remove(
			CLASS_CURRENT_LETTER,
		);
	},

	moveSlider() {
		this.slider.style.transform = `translateX(${
			-this.currentLetterIndex * this.smallButtonSize
		}px)`;
	},
};
